var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.973 9.096a5.91 5.91 0 010-2.192L.132 5.862a.26.26 0 01-.096-.358l1.779-3.016a.26.26 0 01.352-.094L4.016 3.44a6.19 6.19 0 011.94-1.1V.26a.26.26 0 01.26-.26h3.566a.26.26 0 01.26.26v2.08a6.19 6.19 0 011.94 1.1l1.85-1.046a.26.26 0 01.352.094l1.779 3.016a.26.26 0 01-.096.358l-1.842 1.042a5.91 5.91 0 010 2.192l1.841 1.042a.26.26 0 01.097.358l-1.78 3.016a.26.26 0 01-.351.094l-1.85-1.046c-.571.48-1.23.853-1.94 1.1v2.08a.26.26 0 01-.26.26H6.216a.26.26 0 01-.26-.26v-2.08a6.156 6.156 0 01-1.94-1.1l-1.85 1.046a.26.26 0 01-.351-.094L.036 10.496a.26.26 0 01.096-.358l1.841-1.042zM7.903 11a3 3 0 100-6 3 3 0 000 6z",
    fill: "#A7ABB5"
  })));
}
export default __webpack_public_path__ + "static/setting.c0b3ebaf.svg";
export { SvgSetting as ReactComponent };